import { MaterialIcon } from "@website/icons/material";
import { SearchField } from "@website/ui/search-field";
import { deepOmit } from "@website/utils/deep-omit";
import { isFilled } from "@website/utils/is-filled";
import { useDebounce } from "@website/utils/use-debounce/useDebounce";
import { InputTypes } from "@website/widget/filter/filter.types";
import styles from "@website/widget/filter/index.module.scss";
import { useRouter } from "next/router";
import { useEffect, useRef } from "react";

interface Properties extends InputTypes {
  name: string;
}

export const Input = (properties: Properties) => {
  const router = useRouter();
  const { title, name } = properties;
  const { [name]: value } = router.query as Record<string, string>;
  const { debounce } = useDebounce();
  const inputReference = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (!value && inputReference.current?.value)
      inputReference.current.value = "";
  }, [value]);

  function _onChange({ target: { value } }: { target: { value: string } }) {
    debounce(() => {
      router.replace(
        {
          query: deepOmit(
            {
              ...router.query,
              [name]: value.trim()
            },
            isFilled
          )
        },
        undefined,
        { shallow: true, scroll: false }
      );
    }, 300);
  }

  return (
    <div className="pb-4">
      <span className={styles["filter-header"]}>{title}</span>
      <SearchField
        ref={inputReference}
        EndIcon={<MaterialIcon className="text-2xl" name="search" />}
        defaultValue={value}
        disabled={false}
        fullWidth
        onChange={_onChange}
        placeholder={
          ["villa"].includes(process.env.NEXT_PUBLIC_APP_NAME ?? "")
            ? "نام اقامتگاه"
            : "نام هتل"
        }
        size="dense"
      />
    </div>
  );
};
